import { modelT } from "../../redux/features/ui/ui.types";

export const modelsClassicSofaPresets: modelT[] = [
  {
    img: "/images/assets/CollectionImages/bed-bessteller-1.png",
    imageLabel: "sofa-bestseller-1",
    label: "Queen",
    labelUI: "Sofa Plus",
    configurationShortId: "5_ry5eOch",
    subcategory: "Sofas",
  },
  {
    img: "/images/assets/CollectionImages/bed-bessteller-2.png",
    imageLabel: "sofa-bestseller-2",
    label: "Queen",
    labelUI: "Sofa",
    configurationShortId: "eEzQHlgx9",
    subcategory: "Sofas",
  },
  {
    img: "/images/assets/CollectionImages/bed-bessteller-3.png",
    imageLabel: "sofa-bestseller-3",
    label: "Queen",
    labelUI: "Arm Chair",
    configurationShortId: "48iM1V3uO",
    subcategory: "Sofas",
  },
  {
    img: "/images/assets/CollectionImages/bed-bessteller-4.png",
    imageLabel: "sofa-bestseller-4",
    label: "Queen",
    labelUI: "Ottoman",
    configurationShortId: "4Q71LIwJT",
    subcategory: "Rails",
  },
];
